export const withForcedLedgerReadMode = (path: string): string => {
  const [pathname, query = ''] = path.split('?');
  const params = new URLSearchParams(query);

  // Prevent env-dependent read behavior during ledger cutover.
  params.set('useLedger', 'true');

  return `${pathname}?${params.toString()}`;
};
